import axios from "axios";

const legalApi = axios.create({
  // baseURL: "http://localhost:8000/api/v1/",
  baseURL: "https://api-staging.pristinepv.co.uk/api/v1/",
  headers: {
    "Content-Type": "application/json",
  },
});

const LegalApi = () => {
  /**
   * Get current Privacy Policy
   */
  const getCurrentPrivacyPolicy = async () => {
    try {
      const response = await legalApi.get("legal-document/current/privacy-policy");
      return response.data;
    } catch (error) {
      console.error("Get current Privacy Policy API error:", error);
      throw error;
    }
  };

  /**
   * Get current Terms & Conditions
   */
  const getCurrentTerms = async () => {
    try {
      const response = await legalApi.get("legal-document/current/terms");
      return response.data;
    } catch (error) {
      console.error("Get current Terms API error:", error);
      throw error;
    }
  };

  return {
    getCurrentPrivacyPolicy,
    getCurrentTerms,
  };
};

export default LegalApi;
